module.exports = __webpack_public_path__ + "static/media/smallMagentaTemplate.c2977a12.png";